import { FsReducerAction, FsDataState } from '../../type';
import {
  splitCampaignsByAllocation,
  filterVisitorExposedCampaigns,
  searchExposedCampaigns,
  searchUnExposedCampaigns,
  searchNonAllocatedCampaigns as searchRejectedCampaigns,
  forceVariationAllocation,
  forceVariationUnallocation,
  removeForcedVariationUnallocation,
  removeForcedVariationAllocation,
  renderCampaignsAfterDelay,
} from './actions';

export const fsDataInitialState: FsDataState = {
  fsEnvId: '',
  allAcceptedCampaigns: [],
  allExposedCampaigns: [],
  allRejectedCampaigns: [],
  displayedRejectedCampaigns: [],
  displayedExposedCampaigns: [],
  displayedUnexposedCampaigns: [],
  variationsForcedAllocation: {},
  variationsForcedUnallocation: {},
  shouldSendForcedAllocation: false,
  shouldSendForcedUnallocation: false,
  hasReceivedExposureEvent: false,
};

export function fsDataReducer(state: FsDataState, action: FsReducerAction): FsDataState {
  switch (action.type) {
    case 'setBucketingFile':
      return { ...state, bucketingFile: action.bucketingFile };
    case 'updateVisitorVariations': {
      const campaigns = splitCampaignsByAllocation(state, action);
      return {
        ...state,
        visitorData: action.visitorData,
        allocatedVariations: action.value,
        allAcceptedCampaigns: campaigns.allAcceptedCampaigns,
        allRejectedCampaigns: campaigns.allRejectedCampaigns,
        hasReceivedExposureEvent: false,
        sdkInfo: action.sdkInfo,
      };
    }
    case 'updateVisitorExposedVariations': {
      const campaigns = filterVisitorExposedCampaigns(state, action);
      return {
        ...state,
        exposedVariations: action.value,
        allExposedCampaigns: campaigns.displayedExposedCampaigns,
        displayedExposedCampaigns: campaigns.displayedExposedCampaigns,
        displayedUnexposedCampaigns: campaigns.displayedUnexposedCampaigns,
        displayedRejectedCampaigns: campaigns.displayedRejectedCampaigns,
        hasReceivedExposureEvent: true,
      };
    }
    case 'searchFsCampaigns':
      return {
        ...state,
        displayedExposedCampaigns: searchExposedCampaigns(state, action),
        displayedUnexposedCampaigns: searchUnExposedCampaigns(state, action),
        displayedRejectedCampaigns: searchRejectedCampaigns(state, action),
      };
    case 'forceVariationAllocation':
      return forceVariationAllocation(state, action);
    case 'forceVariationUnallocation':
      return forceVariationUnallocation(state, action);
    case 'removeForcedVariationUnallocation':
      return removeForcedVariationUnallocation(state, action);
    case 'removeForcedVariationAllocation':
      return removeForcedVariationAllocation(state, action);
    case 'setShouldSendForcedAllocation':
      return {
        ...state,
        shouldSendForcedAllocation: action.value,
      };
    case 'setShouldSendForcedUnallocation':
      return {
        ...state,
        shouldSendForcedUnallocation: action.value,
      };
    case 'renderCampaignsAfterDelay':
      return renderCampaignsAfterDelay(state);
    default:
      return state;
  }
}
